import React from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import {
  fixedForwardedIPErrorV1013,
  supportsFixedForwardedIPV1013,
} from './forwardedIPConfigV1013';
import './forwardedIPV1013.css';

export default function FixedForwardedIPV1013({ config, type, onChange, t }) {
  const enabled = config.fixed_forwarded_ip_enabled_v1013 === true;
  const error = fixedForwardedIPErrorV1013(config, type);
  return (
    <div
      className='fixed-forwarded-ip-v1013'
      data-testid='fixed-forwarded-ip-v1013'
    >
      <Form.Field>
        <Checkbox
          toggle
          label={t('channel.edit.fixed_forwarded_ip_v1013.enabled')}
          name='fixed_forwarded_ip_enabled_v1013'
          checked={enabled}
          disabled={
            (config.edge_proxy === true ||
              !supportsFixedForwardedIPV1013(type)) &&
            !enabled
          }
          onChange={onChange}
        />
      </Form.Field>
      {enabled && (
        <Form.Input
          id='fixed-forwarded-ip-address-v1013'
          label={t('channel.edit.fixed_forwarded_ip_v1013.address')}
          name='fixed_forwarded_ip_v1013'
          value={config.fixed_forwarded_ip_v1013 || ''}
          placeholder='146.56.174.52'
          autoComplete='off'
          spellCheck={false}
          onChange={onChange}
          error={error ? { content: t(error), pointing: 'above' } : false}
        />
      )}
    </div>
  );
}
